import { menuSectionTypes } from './models';

export const getters = {
  momentOfConsumeList: ({ momentOfConsumeList }) => momentOfConsumeList,
  menuSectionTypesList: (state) => state.menuSectionTypesList,
  templateList: (state) => state.templateList,
  clauseId: (state) => (state.menuSectionTypesList ? state.menuSectionTypesList.find((el) => el.code_name === menuSectionTypes.CLAUSE)?.id : null),
  sectionId: (state) => (state.menuSectionTypesList ? state.menuSectionTypesList.find((el) => el.code_name === menuSectionTypes.SECTION)?.id : null),
  subsectionId: (state) => (state.menuSectionTypesList ? state.menuSectionTypesList.find((el) => el.code_name === menuSectionTypes.SUBSECTION)?.id : null),
  menuFontList: ({ menuFontList }) => menuFontList,
  printMenuSection: (state) => state.printMenuSectionList,
  menuPrintConfiguration: (state) => state.menuPrintConfiguration,
};
